import React from 'react';
import {
  Box, Container, styled, ThemeProvider,
} from '@material-ui/core';

import { SleepioHeader } from '../Onboarding/components/Header/SleepioHeader';

import SleepioResources from './components/SleepioResources';

import { Footer } from '../Onboarding/components/Footer/Footer';
import { ConsentWidget } from '../Onboarding/components/ConsentWidget/ConsentWidget';

import theme from '@/themes/sleepioTheme';

const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

const Resources = () => (
  <ThemeProvider theme={theme}>
    <SleepioHeader />
    <ContentContainer>
      <Container maxWidth="sm">
        <SleepioResources />
      </Container>
    </ContentContainer>
    <ConsentWidget />
    <Footer />
  </ThemeProvider>
);

export default Resources;
